"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var Facebook = function Facebook(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 155.139 155.139"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M89.584 155.14V84.377h23.742l3.562-27.585H89.584v-17.61c0-7.983 2.208-13.424 13.67-13.424l14.595-.007V1.08C115.324.752 106.66 0 96.576 0 75.52 0 61.104 12.853 61.104 36.452v20.34H37.29V84.38h23.814v70.76h28.48z"
  })));
};
var _default = exports.default = Facebook;